import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../Context/AuthContext/AuthContext";
import JobDescriptionService from "../Services/job-description.service";
import {
  findAllJobPostDto,
  LandingPageJobApplication,
} from "../Interface/Index";
import { useLoader } from "../Context/LoaderContext/LoaderContext";

interface UseMyApplicationsReturn {
  userJobApplications: LandingPageJobApplication[];
  pageData: {
    total: number;
    totalPages: number;
  };
}

export const useMyApplications = (
  filters: findAllJobPostDto,
): UseMyApplicationsReturn => {
  const { isUserLoggedIn } = useAuth();
  const { setLoading, setLoadingMessage } = useLoader();

  const jobDescriptionService = new JobDescriptionService();

  const [userJobApplications, setUserJobApplications] = useState<
    LandingPageJobApplication[]
  >([]);
  const [pageData, setPageData] = useState<{
    total: number;
    totalPages: number;
  }>({
    total: 0,
    totalPages: 0,
  });

  const fetchJobApplications = useCallback(async () => {
    try {
      setLoading(true);
      setLoadingMessage("Loading job applications...");

      const response =
        await jobDescriptionService.getAllJobApplicationsOfTheUser(filters);
      setUserJobApplications(response.jobApplications);
      setPageData({
        total: response.pagination.total,
        totalPages: response.pagination.totalPages,
      });
    } catch (err: any) {
      console.error(err);
    } finally {
      setLoading(false);
      setLoadingMessage(null);
    }
  }, [filters]);

  useEffect(() => {
    if (isUserLoggedIn) {
      fetchJobApplications();
    }
  }, [fetchJobApplications, isUserLoggedIn]);

  return {
    userJobApplications,
    pageData,
  };
};
